module.exports = __webpack_public_path__ + "img/Doc18c_Anna Mikhailov.a2818b6c.jpg";